import React from 'react'
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'



const idRender = ({ value }) => {
  return (
    <div style={{ display: 'inline-block', color: value % 2 ? '#7986cb' : '#9ba7b4' }}>
      {value}
    </div>
  )
};

const columns = [
  { name: 'sku_nme', header: 'Product',  defaultWidth: 150 , sortable: false, style: { overflow: 'revert'},},
  { name: 'workplace', header: 'Location', defaultWidth: 130 , sortable: false},
  { name: 'parameter', header: 'Parameter',  defaultWidth: 140, sortable: false,},
  { name: 'val', header: 'Value' ,style: {  textAlign:'center'}, defaultWidth: 60 , sortable: false,},
  { name: 'op', header: ' ',  style: {  textAlign:'center'}, defaultWidth: 30, sortable: false, },
  { name: 'threshold', header: 'Target',  style: {  textAlign:'center'}, defaultWidth: 90, sortable: false, },
  { name: 'color', header: ' ',defaultWidth: 40, sortable: false,
  style: {  textAlign:'center', fontWeight: 'bold' },
   render: ({ value })=>{
     return ( 
          <>
            <span style={
              {
               height: '10px', 
               width: '10px', 
               backgroundColor:value, 
               borderRadius: '50%',
               textAlign:'center', 
               display: 'inline-block'
              }
            } 
            className='dot'>
            </span>          
          </>
        )}
  }
];

const filterValue = [
  { name: 'sku_nme', operator: 'startsWith', type: 'string', value: '' },
  { name: 'workplace', operator: 'startsWith', type: 'string', value: '' },
  { name: 'val', operator: 'startsWith', type: 'string', value: '' },
  { name: 'threshold', operator: 'startsWith', type: 'string', value: '' },
  { name: 'msg', operator: 'startsWith', type: 'string', value: '' },
  { name: 'op', operator: 'startsWith', type: 'string', value: '' },
  { name: 'parameter', operator: 'startsWith', type: 'string', value: '' },
  { name: 'wp', operator: 'startsWith', type: 'string', value: '' },
  { name: 'r_status', operator: 'startsWith', type: 'string', value: '' } ,
];
const defaultSortInfo = [{ name: 'sku_nme', dir: 1 }];

function CTable (props) {
  console.log(props.props.prams['width']);
  const gridStyle = { height: props.props.prams['height'], }
  return (
    <ReactDataGrid
      idProperty="id"
      style={gridStyle}
      columns={columns}
      defaultSortInfo={defaultSortInfo}
      defaultFilterValue={filterValue}
      showZebraRows={false}
      enableColumnAutosize
      dataSource={props.data}
    />
  )
}

export default CTable